$(document).ready(function() {
    $('#salary_two_step_approval').change(function () {
         if($(this).val() == 1) {
            $('.salary_two_step_approval_container').removeClass('hidden');
         } else {
            $('.salary_two_step_approval_container').addClass('hidden');
         }
    });
});
